export default {
  props: {
    products: Array,
    labels: Object,
    showMoreButtonVisible: Boolean,
    showMore: Function,
  },
  template: `
    <div class="col-xl-9">
      <ul class="row list-unstyled">
        <li v-for="product in products" :class="{'col-md-6 col-xl-4 mb-0 mb-sm-1 mb-md-2': product.type === 'product', 'col-md-6 col-xl-8 mb-1 mb-md-2': product.type === 'video', 'col-md-6 col-xl-4 mb-1 mb-md-2': product.type === 'testimonial'}">
          <div v-if="product.type === 'product'" class="card mb-1 mb-sm-0">
            <div class="card-body">
              <span v-if="product.badge" :class="['badge', product.badge.class]">{{ product.badge.name }}</span>
              <div class="row">
                <div class="col-4 col-md-12 pe-0 pe-md-1 m-auto text-center">
                  <div v-if="product.hasPlaceholder" class="product-placeholder">
                    <div class="img-placeholder">
                      <img :src="product.image" width="396" class="img-fluid" alt="">
                    </div>
                  </div>
                  <img v-else :src="product.image" width="396" class="img-fluid card__product-image" alt="">
                </div>
                <div class="col-8 col-md-12 ps-0 ps-md-1">
                  <h6 class="fw-bold my-50"><a class="link-before" :href="product.link">{{ product.name }}</a></h6>
                  <ul class="list-unstyled p-0 m-0 small d-flex flex-wrap align-items-center">
                    <li :class="[attribute.isDivider ? 'card-divider' : 'd-inline-block']" v-for="attribute in product.attributes">{{ attribute.name }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="product.type === 'video'" class="cover">
            <video playsinline="" autoplay="" muted="" loop="" class="w-100" :poster="product.poster">
              <source v-if="product.webm" :src="product.webm" type="video/webm">
              <source v-if="product.mp4" :src="product.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="product.type === 'testimonial'" class="card bg-dark text-light border-0 h-100">
            <div class="card-body p-2 d-flex flex-column justify-content-between">
              <div class="mb-1">
                <ul class="list-unstyled d-flex text-primary mb-1">
                  <li v-for="starClass in product.testimonial.starClasses"><i :class="starClass"></i></li>
                </ul>
                <div class="scroll-y mb-1 fs-xs fw-light">
                  <div class="scroll-content">
                    <p v-html="product.testimonial.text"></p>
                  </div>
                </div>
              </div>
              <h6 class="text-white m-0 text-uppercase smaller">{{ product.testimonial.source }}</h6>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="showMoreButtonVisible" class="my-2 mb-lg-0 text-center">
        <a @click.prevent="showMore" class="btn btn-outline-primary" href="#">{{ labels.showMore }}</a>
      </div>
    </div>
`
}
